;(function () {
  'use strict'

  angular
    .module('contrast.trace.events')
    .controller('csTraceEventLinesCtrl', csTraceEventLinesCtrl)

  function csTraceEventLinesCtrl(
    $filter,
    he,
    syntaxHighlighter,
    TRACE_EVENT_LINE_TYPES
  ) {
    'ngInject'

    var vm, _limit

    this.$onInit = function () {
      vm = this
      angular.extend(vm, {
        getLineView: getLineView,
        getLimit: getLimit,
        getDiff: getDiff,
        useLimit: useLimit,
        hasChildren: hasChildren,
        getFragmentClass: getFragmentClass
      })

      init()
    }

    function init() {
      if (vm.csTraceEventLinesTruncate) {
        vm.lineView = _truncate(vm.csTraceEventLines)
      } else {
        vm.lineView = _buildView(vm.csTraceEventLines)
      }
      _limit = _initLimit(vm.csTraceEventLinesLimit)
    }

    function _buildView(originalLines) {
      var line,
        lineCopy,
        i,
        len,
        view = []
      for (i = 0, len = originalLines.length; i < len; i++) {
        line = originalLines[i]
        lineCopy = angular.copy(line)
        transformLineCopyForView(lineCopy)
        view.push(lineCopy)
      }
      return view
    }

    function _truncate(originalLines) {
      var truncateData = {
        totalChars: 0
      }
      var line,
        i,
        len,
        view = [],
        lineCopy
      for (i = 0, len = originalLines.length; i < len; i++) {
        line = originalLines[i]
        if (
          truncateData.totalChars + line.text.length <=
          vm.csTraceEventLinesTruncate
        ) {
          truncateData.totalChars += line.text.length
          // update view - add line
          lineCopy = angular.copy(line)
          transformLineCopyForView(lineCopy)
          view.push(lineCopy)
        } else {
          // figure out which fragments for this line will be kept, which one will be truncated, and which ones will be dropped
          lineCopy = angular.copy(line)
          transformLineCopyForView(lineCopy)
          lineCopy.fragments = _truncateFragments(
            truncateData,
            lineCopy.fragments
          )
          view.push(lineCopy)
          return view
        }
      }
      return view
    }

    // Transform line values for the view
    function transformLineCopyForView(line) {
      line.text = decode(line.text)

      var i, len, fragment
      for (i = 0, len = line.fragments.length; i < len; i++) {
        fragment = line.fragments[i]

        fragment.value = decode(fragment.value)
        fragment.value = addSyntaxHighlighting(fragment)

        // Update value for view (remember, this is a copy of the raw data, it is the view)
        line.fragments[i].value = fragment.value
      }
    }

    function decode(str) {
      return he.decode(str)
    }

    function addSyntaxHighlighting(fragment) {
      if (
        fragment.type === TRACE_EVENT_LINE_TYPES.SOURCE_CODE &&
        angular.isString(fragment.language)
      ) {
        fragment.hasSyntaxHighlighting = true
        return syntaxHighlighter.highlight(fragment.value, fragment.language)
      }
      return fragment.value
    }

    function _truncateFragments(truncateData, fragments) {
      var i,
        len,
        fragment,
        view = [],
        fragmentView
      for (i = 0, len = fragments.length; i < len; i++) {
        fragment = fragments[i]
        if (
          fragment.value.length + truncateData.totalChars <
          vm.csTraceEventLinesTruncate
        ) {
          truncateData.totalChars += fragment.value.length
          view.push(angular.copy(fragment))
        } else if (
          fragment.value.length + truncateData.totalChars ===
          vm.csTraceEventLinesTruncate
        ) {
          truncateData.totalChars += fragment.value.length
          view.push(angular.copy(fragment))
          return view
        } else {
          // truncate this fragment
          var end = Math.abs(
            fragment.value.length +
              truncateData.totalChars -
              vm.csTraceEventLinesTruncate
          )
          end = fragment.value.length - end
          if (end === fragment.value.length) {
            return view
          }
          fragmentView = angular.copy(fragment)
          fragmentView.value = fragmentView.value.substr(0, end).trimRight()
          fragmentView.truncated = true
          //fragment.value = fragment.value.substr(0, end-1);
          truncateData.totalChars += fragmentView.value.length
          view.push(fragmentView)
          return view
        }
      }
      return view
    }

    function hasChildren(line) {
      return angular.isArray(line.children) && line.children.length > 0
    }

    function _initLimit(limit) {
      if (!angular.isNumber(limit)) {
        return 0
      }
      return limit
    }

    function getLineView() {
      var lines = vm.lineView
      if (useLimit()) {
        return lines.slice(0, _limit)
      }
      return lines
    }

    function getLimit() {
      return _limit
    }

    function getDiff() {
      return vm.lineView.length - _limit
    }

    function useLimit() {
      return _limit && _limit < vm.lineView.length
    }

    function getFragmentClass(fragment) {
      var c = $filter('snakeCase')(fragment.type)
      if (fragment.truncated) {
        return c + ' ellipsis'
      }
      return c
    }
  }
})()
